module.exports = __webpack_public_path__ + "img/PHONE.9b60b5fd.svg";